import { render, staticRenderFns } from "./WorldWideList.vue?vue&type=template&id=089688c9&"
import script from "./WorldWideList.vue?vue&type=script&lang=js&"
export * from "./WorldWideList.vue?vue&type=script&lang=js&"
import style0 from "./WorldWideList.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports